import React from 'react'
import SlotRowSkeleton from '../SlotRowSkeleton'
import '../index.scss'

const SlotGridSkeleton: React.FC<{
  slots?: number
}> = ({ slots }) => {
  return (
    <div className="~flex ~flex-col ~w-full">
      <SlotRowSkeleton slots={slots} />
      <SlotRowSkeleton slots={slots} />
      <SlotRowSkeleton slots={slots} />
      <SlotRowSkeleton slots={slots} />
      <SlotRowSkeleton slots={slots} isLast />
    </div>
  )
}

export default SlotGridSkeleton
